import React from 'react';

export default ({
  className,
  isInStock,
  hasLowStock,
  stockStatusDescription,
}) => {
  const stockClass = isInStock
    ? hasLowStock
      ? 'low-stock'
      : 'in-stock'
    : 'out-of-stock';
  return (
    <span
      className={`product-stock-status product-stock-status--${stockClass} ${className}`}
    >
      {stockStatusDescription}
    </span>
  );
};
